// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-con[data-v-d3256290] {\n  margin-bottom: 12px;\n}\n.label-con .icon[data-v-d3256290] {\n  width: 4px;\n  height: 14px;\n  background: #165DFF;\n  border-radius: 0 0 0 0;\n  margin-right: 8px;\n}\n.label-con .label[data-v-d3256290] {\n  font-family: PingFang SC, PingFang SC, serif;\n  font-weight: bold;\n  font-size: 16px;\n  color: #1D2129;\n  line-height: 24px;\n  text-align: left;\n  font-style: normal;\n  text-transform: none;\n}", ""]);
// Exports
module.exports = exports;
